import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../Footer";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { toTitleCase } from "../helper/formatCarName";
import { SkeletonCard } from "../components/SkeletonLoader";
import CarCard from "../components/CarCard";


const AcceptedOffer = () => {
  const navigate = useNavigate();
  const [pendingList, setPendingList] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };
  const storedUserPreferences = getDataFromlocalStorage("userData");
  useEffect(() => {
    if (storedUserPreferences === null) {
      Swal.fire({
        title: "Unauthorized",
        text: "You need to be logged in to access this page",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Log In Now",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/login");
        } else {
          navigate("/");
        }
      });
      return;
    } else if (storedUserPreferences?.role !== "dealer") {
      Swal.fire({
        title: "Unauthorized Access",
        text: "Only dealer can access this!",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Back To Home",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/");
        } else {
          navigate("/");
        }
      });
      return;
    }
  }, []);
  const fetchData = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/get/bidder/bids",
        {
          bidder_id: storedUserPreferences?.id,
        }
      );

      const filteredData = response?.data.biddings.filter(
        (item) => item.status === "accept"
      );

      setPendingList(filteredData);
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    } finally {
      setPageLoading(false);
    }
  };
  function formatEuroAmount(amount) {
    const parts = amount.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  useEffect(() => {
    fetchData();
  }, []);
function backto(){
  window.history.back();
}
  return (
    <>
      <Navbar />
      <div className="cl-page">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
            <div>
              <h3 className="cl-page-title">Accepted Offers</h3>
              <p className="cl-page-subtitle">Offers you have accepted</p>
            </div>
            <button onClick={backto} type="button" className="cl-btn cl-btn-outline cl-btn-sm">
              <i className="fa fa-arrow-left me-1"></i>Back
            </button>
          </div>
          <div className="row g-3">
            {pageLoading ? (
              <SkeletonCard count={8} />
            ) : pendingList?.length === 0 ? (
              <div className="cl-empty">
                <div className="cl-empty-icon"><i className="fa-solid fa-handshake"></i></div>
                <h6 className="cl-empty-title">No Accepted Offers</h6>
                <p className="cl-empty-text">You haven't accepted any offers yet.</p>
              </div>
            ) : (
            pendingList?.map((car) => (
              <div
                key={car?.id}
                className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6"
              >
                <CarCard
                  carData={car?.car}
                  extraBodyContent={
                    <div className="mt-2 pt-2" style={{ borderTop: "1px solid #eee" }}>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <span style={{ fontSize: "11px", color: "#777" }}>Offer Amount</span>
                        <span className="fw-bold" style={{ fontSize: "13px", color: "#00889c" }}>£{formatEuroAmount(car.amount)}</span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <span style={{ fontSize: "11px", color: "#777" }}>Request Type</span>
                        <span className="fw-semibold text-capitalize" style={{ fontSize: "12px" }}>{car.bid_request}</span>
                      </div>
                      <div className="d-flex justify-content-center mt-2">
                        <span className="badge" style={{ backgroundColor: "#28a745", color: "#fff", fontSize: "11px", padding: "4px 12px", borderRadius: "6px" }}>
                          <i className="fa-solid fa-check me-1"></i>Accepted
                        </span>
                      </div>
                    </div>
                  }
                  hideFooter={true}
                />
              </div>
            ))
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AcceptedOffer;
